import { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, GlobalReducer, GobalState } from "./global-reducer";

const GlobalContext = createContext<GobalState | undefined >(undefined);
const GlobalContextDispatchContext = createContext({} as any);

const GlobalProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(GlobalReducer, {} as GobalState);

    return (
        <GlobalContext.Provider value={state}>
            <GlobalContextDispatchContext.Provider value={dispatch}>
                {children}
            </GlobalContextDispatchContext.Provider>
        </GlobalContext.Provider>
    );
}


const useGlobalState = () => {
    const context = useContext(GlobalContext);
    if (context === undefined) {
        throw new Error('useGlobalState must be used within a GlobalProvider');
    }
    return context;
}

const useGlobalDispatch = () => {
    const context =  useContext(GlobalContextDispatchContext);
    if (context === undefined) {
        throw new Error('useGlobalDispatch must be used within a GlobalProvider');
    }
    return context;
}

export { GlobalProvider, useGlobalState, useGlobalDispatch, ACTION_TYPES };